"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _autocomplete = _interopRequireDefault(require("./autocomplete"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
* Tencent is pleased to support the open source community by making SPA UI available.
* Copyright (C) 2019, a Tencent company. All rights reserved.
*/

/**
 * @fileoverview 导出组件
 * @author kirkzheng
 */
var _default = _autocomplete["default"];
exports["default"] = _default;